import styled from 'styled-components'

export const ContainerPage = styled.div`
  background-color: rgb(255, 255, 255);
  overflow-x: hidden;
  display: block;
  position: relative;
  left: 0;
  width: 100%;
  height: 100vh;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  transition: all 500ms ease-in-out;
  padding-bottom: 5%;
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: rgb(219, 219, 219);
    border-radius: 10px;
  }
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3);
  }
  ::-webkit-scrollbar-thumb {
    background-color: darkgrey;
    border-radius: 20px;
    outline: 1px solid slategrey;
  }
  @media screen and (max-width: 820px) {
    position: fixed;
    display: flex;
    bottom: 10%;
    left: 0;
    width: 100%;
    height: 70vh;
    background-color: rgb(255, 255, 255);
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    border-bottom-left-radius: 0px;
    z-index: 1;
  }
  @media screen and (max-width: 500px) {
    position: fixed;
    bottom: 10%;
    display: flex;
    left: 0;
    width: 100%;
    height: 70%;
    background-color: rgb(255, 255, 255);
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    border-bottom-left-radius: 0px;
    z-index: 0;
  }
`
export const ContainerPage1 = styled.div`
  position: fixed;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 10%;
  width: 90%;
  height: 100vh;
  background-color: rgb(255, 255, 255);
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  z-index: 0;
  @media screen and (max-width: 820px) {
    position: fixed;
    display: flex;
    bottom: 10%;
    left: 0;
    width: 100%;
    height: 70vh;
    background-color: rgb(255, 255, 255);
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    border-bottom-left-radius: 0px;
    z-index: 1;
  }
  @media screen and (max-width: 500px) {
    position: fixed;
    bottom: 10%;
    display: flex;
    left: 0;
    width: 100%;
    height: 70%;
    background-color: rgb(255, 255, 255);
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    border-bottom-left-radius: 0px;
    z-index: 0;
  }
`
export const ContainerPage2 = styled.div`
  width: 100%;
  height: 100vh;
  padding-top: 15px;
  display: grid;
  place-items: center;
  position: relative;
  background-color: rgb(255, 255, 255);
  ::-webkit-scrollbar {
    width: 5px;
    background-color: rgb(255, 255, 255);
    border-radius: 10px;
  }
  @media print {
    height: 100%;
    padding: 5%;
  }
`
export const ContainerPageRel = styled.div`
position: absolute;
place-items: center;
padding-top: 5%;
overflow: auto;
display: flex;
flex-direction: column;
width: 100%;
height: 100%;
background-color: rgb(255, 255, 255);
border-top-left-radius: 0px;
border-bottom-left-radius: 0px;
`

export const TitleOfPage = styled.div`
  display: flex;
  position: relative;
  left: 5%;
  width: 90%;
  height: 100%;
  /* background-color: blue; */
`
export const TitleOfPageRel = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  gap: 30rem;
  width: 80vw;
  height: 100px;
  /* background-color: #d8d8d8; */
  /* border: 1px solid #000; */
  @media print {
    gap: 15rem;
    width: 90vw;
  }
`
export const TitlePageRel = styled.h5`
  position: absolute;
  display: flex;
  width: 35vw;
  right: 0;
  justify-content: center;
  text-align: center;
  align-items: center;
  font-family: Roboto-Medium;
  font-size: 20px;
  border-style: none;
  background: #077e1a;
  border-radius: 25px;
  color: #fff;
  z-index: 2;
  @media print {
    position: absolute;
    display: flex;
    width: 50vw;
    right: 0;
    justify-content: center;
    text-align: center;
    align-items: center;
    font-family: Roboto-Medium;
    font-size: 18px;
    border-style: none;
    background: #077e1a;
    border-radius: 25px;
    color: #fff;
    z-index: 2;
  }
`
export const RelForm = styled.div`
  position: relative !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  background: transparent;
  // line-height: 12px !important;
  width: 80%;
  @media screen and (max-width: 820px) {
    flex-direction: column !important;
    width: 90% !important;
    height: 800px !important;
  }
`
export const RelFormFormulario6 = styled.div`
  position: relative !important;
  display: flex !important;
  align-items: center !important;
  text-align: center !important;
  justify-content: center !important;
  background: transparent;
  width: 80vw;
  background: #fff;
  color: #077e1a;
  border: 2px solid #077e1a;
  padding: 16px;
  margin-top: 20px;
  font-size: 14px;
  font-family: Roboto-Medium;
  @media print {
    width: 90vw;
  };
  @media screen and (max-width: 820px) {
    flex-direction: column !important;
    width: 90%;
  }
`
export const RelFormFormulario7 = styled.div`
  position: relative !important;
  display: flex !important;
  // align-items: top !important;
  // text-align: left !important;
  // justify-content: left !important;
  background: transparent;
  background: #fff;
  color: #077e1a;
  //border: 0px solid #077e1a !important;
  //padding: 16px;
  margin-left: 10px;
  font-size: 14px;
  font-family: Roboto-Medium;
`

export const TabelaPadraoRelatorio = styled.div`
  position: relative;
  width: 80vw;
  background-color: rgb(255, 255, 255);
  z-index: 5;
  margin-top: 20px;
  @media print {
    width: 90vw;
  }
`
export const TabelaPadraoRelatorio2 = styled.div`
  position: relative;
  width: 80vw;
  background-color: rgb(255, 255, 255);
  z-index: 5;
  @media print {
    width: 90vw;
  }
`
export const TitlePageRel1 = styled.h5`
  position: relative;
  width: 80vw;
  font-size: 20px;
  font-family: Roboto-Medium;
  border-top: 0px solid #077e1a;
  border-bottom: 4px solid #077e1a;
  margin-top: 10px;
  margin-bottom: 10px;
  background: transparent;
  color: #077e1a;
  @media print {
    position: relative;
    top: 0;
    width: 90vw;
    font-size: 18px;
    font-family: Roboto-Medium;
    border-top: 2px solid #077e1a;
    border-bottom: 2px solid #077e1a;
    margin-top: 10px;
    margin-bottom: 10px;
    background: transparent;
    color: #077e1a;
  };
  @media screen and (max-width: 820px) {
    flex-direction: column !important;
    width: 90% !important;
    align-items: center !important;
    Text-align: center !important;
  }
`
export const TitlePageRel2 = styled.h5`
  font-family: Roboto-Medium;
  //border-top: 2px solid #077e1a;
  border-bottom: 2px solid #077e1a;
  color: #077e1a;
  position: relative;
  width: 80vw;
  font-size: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
  background: transparent;
  @media print {
    width: 90vw;
  };
  @media screen and (max-width: 820px) {
    Text-align: center !important;
  }
`
export const TitlePageRelTab = styled.h5`
  font-family: Roboto-Medium;
  //border-top: 2px solid #077e1a;
  border-bottom: 2px solid #077e1a;
  color: #077e1a;
  position: relative;
  font-size: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
  background: transparent;
  @media print {
    width: 90vw;
  };
  @media screen and (max-width: 820px) {
    Text-align: center !important;
  }
`
export const TitleOfPage2 = styled.div`
  display: flex;
  position: relative;
  padding-bottom: 60px;
  top: 100%;
  left: 0%;
  width: 45%;
  height: 10%;
  background-color: transparent;
  @media screen and (max-width: 820px) {
    display: flex;
    position: relative;
    padding-bottom: 60px;
    top: 100%;
    left: 0%;
    width: 45%;
    height: 10%;
    background-color: transparent;
  }
`
export const DataAudit = styled.h5`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 30%;
  font-size: 20px;
  font-family: Roboto-Medium;
  border-style: none;
  background: transparent;
  color: #077e1a;
  @media print {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 35%;
    font-size: 18px;
    font-family: Roboto-Medium;
    border-style: none;
    background: transparent;
    color: #077e1a;
    z-index: 2;
  };
  @media screen and (max-width: 820px) {
    position: relative !important;
    margin-top: 10px;
    width: 90%;
    background-color: transparent;
    Text-align: center !important;
  }
`
export const CxAssign = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  background: transparent; 
  margin-top: 100px;
  /* border: 1px solid black; */
  height: 200px;
  width: 80vw;
  @media print {
    position: relative;
    display: flex;
    align-items: center;
    background: transparent;
    /* border: 1px solid black; */
    height: 200px;
    width: 80vw;
  }
`
export const Assign = styled.h5`
  position: absolute;
  margin-top: 100px;
  display: flex;
  flex-direction: column;
  width: 30%;
  height: 100%;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 1rem;
  font-family: Roboto-Medium;
  /* border: 1px solid black; */
  background: transparent;
  color: #333;
  z-index: 99;
`
export const Assign2 = styled.h5`
  position: absolute;
  margin-top: 100px;
  display: flex;
  flex-direction: column;
  width: 30%;
  height: 100%;
  right: 0;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 1rem;
  font-family: Roboto-Medium;
  /* border: 1px solid black; */
  background: transparent;
  color: #333;
  z-index: 99;
`
export const Nota = styled.h5`
  position: absolute;
  top: 30%;
  right: 10%;
  font-size: clamp(0.1em, 0.1em + 1.5vw, 1.5em);
  font-family: Roboto-Medium;
  border-style: none;
  background: transparent;
  color: #333;
  width: 280px;
  z-index: 2;
`
export const Nota2 = styled.h5`
  position: absolute;
  top: 600px;
  width: 100%;
  line-height: 35px;
  left: 0;
  justify-content: center;
  text-align: center;
  padding-top: 2%;
  padding-bottom: 2%;
  font-size: clamp(0.1em, 0.1em + 1.5vw, 1.5em);
  font-family: Roboto-Medium;
  border-style: none;
  background: transparent;
  color: #333;
  z-index: 2;
`
export const TitlePage1 = styled.h5`
  position: absolute;
  top: 0%;
  left: 0%;
  border-radius: 20px;
  width: 80%;
  line-height: 20px;
  display: block;
  font-size: clamp(0.1em, 0.1em + 1.4vw, 1.4em);
  font-family: Roboto-Bold;
  color: #adadad;
  @media screen and (max-width: 820px) {
    position: absolute;
    top: 0%;
    left: 0%;
    border-radius: 20px;
    width: 80%;
    line-height: 20px;
    display: block;
    font-size: 16px;
    font-family: Roboto-Bold;
    color: #adadad;
  }
`
export const TitlePage2 = styled.h5`
  position: absolute;
  top: 45px;
  left: 0%;
  height: 30%;
  display: flex;
  align-items: center;
  font-size: 25px;
  font-family: Roboto-Bold;
  border-style: none;
  /* background-color: red; */
  background-color: transparent;
  color: #077e1a;
  z-index: 2;
`
export const TitlePage3 = styled.h5`
  position: relative;
  left: 0;
  top: 25px;
  font-size: 16px;
  font-family: Roboto-Regular;
  border-style: none;
  background: transparent;
  line-height: 20px;
  color: #077e1a;
  z-index: 2;
`
export const TitlePage4 = styled.h5`
  position: absolute;
  left: 5%;
  font-family: Roboto-Bold;
  font-size: clamp(0.1em, 0.1em + 1.5vw, 1.5em);
  border-style: none;
  line-height: 20px;
  background: transparent;
  color: #077e1a;
  z-index: 2;
`
export const TitlePage5 = styled.h5`
  position: absolute;
  top: 0;
  left: 0;
  font-family: Roboto-Bold;
  font-size: clamp(0.1em, 0.1em + 2vw, 2em);
  border-style: none;
  background: transparent;
  color: #077e1a;
  z-index: 2;
`
export const TitlePage6 = styled.h5`
  position: absolute;
  bottom: 0;
  left: 0;
  font: clamp(0.01em, 0.01em + 1.8vw, 1.8em) Roboto-Bold;
  border-style: none;
  background: transparent;
  color: #077e1a;
  z-index: 2;
`
export const TitlePage7 = styled.h5`
  position: absolute;
  top: 25%;
  left: 0%;
  font-size: clamp(0.1em, 0.1em + 1.4vw, 1.4em);
  font-family: Roboto-Bold;
  border-style: none;
  background: transparent;
  color: #077e1a;
  z-index: 2;
`
export const TitlePage8 = styled.h5`
  position: absolute;
  bottom: 10%;
  left: 0;
  font-size: 18px;
  font-family: Roboto-Medium;
  border-style: none;
  background: transparent;
  color: #077e1a;
  z-index: 2;
  @media screen and (max-width: 620px) {
    position: absolute;
    bottom: 20%;
    left: 0;
    font-size: 16px;
    font-family: Roboto-Medium;
    border-style: none;
    background: transparent;
    color: #077e1a;
    z-index: 2;
  }
`
export const TitlePage9 = styled.h5`
  position: absolute;
  bottom: 40%;
  left: 0;
  width: 80%;
  font: clamp(0.01em, 0.01em + 1.4vw, 1.4em) Roboto-Bold;
  line-height: 18px;
  border-style: none;
  /* background: red; */
  color: #077e1a;
  z-index: 2;
`
